export default class {
  update (repository, resource, { context, data }) {
    const path = resource.path + '?' + Object.keys(context).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(context[key])).join('&')

    console.log(data)

    repository.update(path, {
      items: data.data,
      total: data.meta.total
    })
  }
}